<!--
 * @Description: 教学工作检查
 * @Author: ztw
 * @Date: 2023-03-27 11:23:55.377
 * @LastEditors: PF
 * @LastEditTime: 2024-02-04 15:19:50
-->
<template>
  <div class="list-page">
    <el-dialog class="wp90 hp90" :model-value="openJiaoXueJianCha" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">教学检查</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openJiaoXueJianCha', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header>
          <div style="display:flex;margin-bottom: 12px;">
            <span>组名：{{ zm }}</span>
            <span style="margin-left:20px">检查人数：{{ ccrs }}</span>
            <span style="margin-left:20px">时间段：{{ cckssj }}至{{ ccjssj }}</span>
            <span style="margin-left:20px">每人检查数量：{{ mrccsl }}</span>
            <span v-for="(item, index) in pcData" :key="index">
              <span v-if="pc == item.value" style="margin-left:20px">频次：{{ item.name }}</span>
            </span>
          </div>
        </el-header>
        <el-main>
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" width="60" fixed align="center" />
            <el-table-column label="教师姓名" prop="jsxm" min-width="150" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- 冻结列-Left END -->
            <el-table-column label="教学日志" align="center" show-overflow-tooltip>
              <el-table-column label="应交/实交/检查" min-width="120" align="center">
                <template #default="scope">
                  <span>{{ scope.row.jxrzyjs || 0 }}/{{ scope.row.jxrzsjs || 0 }}/{{ scope.row.jxrzjcs || 0 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平均分" min-width="100" prop="jxrzjcpjf" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            </el-table-column>
            <el-table-column label="作业批改" align="center" show-overflow-tooltip>
              <el-table-column label="应交/实交/检查" min-width="120" align="center">
                <template #default="scope">
                  <span>{{ scope.row.zypgyjs || 0 }}/{{ scope.row.zypgsjs || 0 }}/{{ scope.row.zypgjcs || 0 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平均分" min-width="100" prop="zypgjcpjf" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            </el-table-column>
            <el-table-column label="教学设计" align="center" show-overflow-tooltip>
              <el-table-column label="应交/实交/检查" min-width="120" align="center">
                <template #default="scope">
                  <span>{{ scope.row.jxsjyjs || 0 }}/{{ scope.row.jxsjsjs || 0 }}/{{ scope.row.jxsjjcs || 0 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平均分" min-width="100" prop="jxsjjcpjf" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            </el-table-column>
            <el-table-column label="课件" align="center" show-overflow-tooltip>
              <el-table-column label="应交/实交/检查" min-width="120" align="center">
                <template #default="scope">
                  <span>{{ scope.row.kjyjs || 0 }}/{{ scope.row.kjsjs || 0 }}/{{ scope.row.kjjcs || 0 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平均分" min-width="100" prop="kjjcpjf" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            </el-table-column>
            <el-table-column label="备课" align="center" show-overflow-tooltip>
              <el-table-column label="应交/实交/检查" min-width="120" align="center">
                <template #default="scope">
                  <span>{{ scope.row.bkyjs || 0 }}/{{ scope.row.bksjs || 0 }}/{{ scope.row.bkjcs || 0 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="平均分" min-width="100" prop="bkjcpjf" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            </el-table-column>
            <el-table-column label="检查方式" prop="jcff" width="120" fixed="right" align="center" show-overflow-tooltip :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span v-if="scope.row.jcff === 1">全部检查</span>
                <span v-if="scope.row.jcff === 2">抽查</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" fixed="right" align="center">
              <template #default="scope">
                <el-button link type="success" @click="openJianChaDetail = true; row = { jxgzjcid: scope.row.id, lx: 'xiangQing' }">详情</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
    </el-dialog>
  </div>
  <jianchadetail v-if="openJianChaDetail" v-model:openJianChaDetail="openJianChaDetail" :row="row" @ReturnData="bindTable()" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import {
  loadList,
  closeWindow,
  loadSelect
} from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import jianchadetail from './jianchadetail.vue'

const props = defineProps({
  openJiaoXueJianCha: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openJiaoXueJianCha', 'ReturnData'])

const zm = ref('')
const ccrs = ref('')
const ccjssj = ref('')
const cckssj = ref('')
const mrccsl = ref('')
const pc = ref('')

// 加载频次下拉框
const pcData = ref({})
loadSelect({ url: '/api/v2/jiaowu/jiaoxuegongzuozu/pinci', data: pcData })

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'jsid', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.jxgzjcjlid = props.row.jxgzjcjlid || undefined
  loadList({
    url: '/api/v2/jiaowu/jiaoxuegongzuojiancha/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      zm.value = dataGrid.value.data[0].zm
      ccrs.value = dataGrid.value.data[0].ccrs
      ccjssj.value = dataGrid.value.data[0].ccjssj
      cckssj.value = dataGrid.value.data[0].cckssj
      mrccsl.value = dataGrid.value.data[0].mrccsl
      pc.value = dataGrid.value.data[0].pc
      dataGrid.value.multipleSelection = []
    }
  })
}
bindTable()

// 弹窗
const row = ref()
const openJianChaDetail = ref(false)

watch(
  () => props.openJiaoXueJianCha,
  () => {
    if (props.openJiaoXueJianCha) {
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>
